import { LiItem } from "@faire/help-center-self-serve/brand/instantAnswers/instantAnswersComponents/common/LiItem";
import retailerSettingsProfile from "@faire/web-api/routes/retailer/settings/profile";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { Bold } from "@faire/web/ui/Typography/Span";
import React from "react";
export var ResetOrUpdatePasswordIA = function ResetOrUpdatePasswordIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qQ6HjO",
    defaultMessage: "You have two options for managing your password:"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "4bZNDG",
    defaultMessage: "Reset your password, if you\u2019ve forgotten it:"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "1ShK6n",
    defaultMessage: "Click <BoldFormatting>Sign In</BoldFormatting> in the top right corner of the homepage",
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "A45LYr",
    defaultMessage: "Enter your email address and press Enter"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "yaYwDM",
    defaultMessage: "Click <BoldFormatting>Forgot your password? Reset It</BoldFormatting>",
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3dToYM",
    defaultMessage: "Check your email (including spam) for a password reset link"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "l36AqR",
    defaultMessage: "Follow the instructions in the email to reset your password"
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(Bold, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Rp+OL4",
    defaultMessage: "Update your password, if you know your current password:"
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3bw68g",
    defaultMessage: "Go to your <AccountSettingLinkFormatting>Settings</AccountSettingLinkFormatting> page",
    values: {
      AccountSettingLinkFormatting: AccountSettingLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Lv/yn9",
    defaultMessage: "Navigate to <BoldFormatting>My profile</BoldFormatting>",
    values: {
      BoldFormatting: BoldFormatting
    }
  })), " "), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EaN/2z",
    defaultMessage: "Find the <BoldFormatting>Password</BoldFormatting> section and follow the prompts to change your password.",
    values: {
      BoldFormatting: BoldFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nUHkRv",
    defaultMessage: "If you\u2019re having trouble resetting or updating your password, please contact us using the options below."
  })));
};
var BoldFormatting = function BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};
var AccountSettingLinkFormatting = function AccountSettingLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: retailerSettingsProfile(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};